import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import './checkbox.css';
import * as DOM from '../../dom.js';
import { Widget } from '../widget.js';
import { Color } from '../../../common/color.js';
import { Emitter } from '../../../common/event.js';
var defaultOpts = {
  inputActiveOptionBorder: Color.fromHex('#007ACC00'),
  inputActiveOptionForeground: Color.fromHex('#FFFFFF'),
  inputActiveOptionBackground: Color.fromHex('#0E639C50')
};
export var Checkbox = /*#__PURE__*/function (_Widget) {
  _inherits(Checkbox, _Widget);

  var _super = _createSuper(Checkbox);

  function Checkbox(opts) {
    var _this;

    _classCallCheck(this, Checkbox);

    _this = _super.call(this);
    _this._onChange = _this._register(new Emitter());
    _this.onChange = _this._onChange.event;
    _this._onKeyDown = _this._register(new Emitter());
    _this.onKeyDown = _this._onKeyDown.event;
    _this._opts = Object.assign(Object.assign({}, defaultOpts), opts);
    _this._checked = _this._opts.isChecked;
    var classes = ['monaco-custom-checkbox'];

    if (_this._opts.icon) {
      classes.push(_this._opts.icon.classNames);
    } else {
      classes.push('codicon'); // todo@aeschli: remove once codicon fully adopted
    }

    if (_this._opts.actionClassName) {
      classes.push(_this._opts.actionClassName);
    }

    classes.push(_this._checked ? 'checked' : 'unchecked');
    _this.domNode = document.createElement('div');
    _this.domNode.title = _this._opts.title;
    _this.domNode.className = classes.join(' ');
    _this.domNode.tabIndex = 0;

    _this.domNode.setAttribute('role', 'checkbox');

    _this.domNode.setAttribute('aria-checked', String(_this._checked));

    _this.domNode.setAttribute('aria-label', _this._opts.title);

    _this.applyStyles();

    _this.onclick(_this.domNode, function (ev) {
      _this.checked = !_this._checked;

      _this._onChange.fire(false);

      ev.preventDefault();
    });

    _this.ignoreGesture(_this.domNode);

    _this.onkeydown(_this.domNode, function (keyboardEvent) {
      if (keyboardEvent.keyCode === 10
      /* Space */
      || keyboardEvent.keyCode === 3
      /* Enter */
      ) {
        _this.checked = !_this._checked;

        _this._onChange.fire(true);

        keyboardEvent.preventDefault();
        return;
      }

      _this._onKeyDown.fire(keyboardEvent);
    });

    return _this;
  }

  _createClass(Checkbox, [{
    key: "enabled",
    get: function get() {
      return this.domNode.getAttribute('aria-disabled') !== 'true';
    }
  }, {
    key: "focus",
    value: function focus() {
      this.domNode.focus();
    }
  }, {
    key: "checked",
    get: function get() {
      return this._checked;
    },
    set: function set(newIsChecked) {
      this._checked = newIsChecked;
      this.domNode.setAttribute('aria-checked', String(this._checked));

      if (this._checked) {
        this.domNode.classList.add('checked');
      } else {
        this.domNode.classList.remove('checked');
      }

      this.applyStyles();
    }
  }, {
    key: "width",
    value: function width() {
      return 2
      /*marginleft*/
      + 2
      /*border*/
      + 2
      /*padding*/
      + 16
      /* icon width */
      ;
    }
  }, {
    key: "style",
    value: function style(styles) {
      if (styles.inputActiveOptionBorder) {
        this._opts.inputActiveOptionBorder = styles.inputActiveOptionBorder;
      }

      if (styles.inputActiveOptionForeground) {
        this._opts.inputActiveOptionForeground = styles.inputActiveOptionForeground;
      }

      if (styles.inputActiveOptionBackground) {
        this._opts.inputActiveOptionBackground = styles.inputActiveOptionBackground;
      }

      this.applyStyles();
    }
  }, {
    key: "applyStyles",
    value: function applyStyles() {
      if (this.domNode) {
        this.domNode.style.borderColor = this._checked && this._opts.inputActiveOptionBorder ? this._opts.inputActiveOptionBorder.toString() : 'transparent';
        this.domNode.style.color = this._checked && this._opts.inputActiveOptionForeground ? this._opts.inputActiveOptionForeground.toString() : 'inherit';
        this.domNode.style.backgroundColor = this._checked && this._opts.inputActiveOptionBackground ? this._opts.inputActiveOptionBackground.toString() : 'transparent';
      }
    }
  }, {
    key: "enable",
    value: function enable() {
      this.domNode.tabIndex = 0;
      this.domNode.setAttribute('aria-disabled', String(false));
    }
  }, {
    key: "disable",
    value: function disable() {
      DOM.removeTabIndexAndUpdateFocus(this.domNode);
      this.domNode.setAttribute('aria-disabled', String(true));
    }
  }]);

  return Checkbox;
}(Widget);